import { render, staticRenderFns } from "./BackToCart.vue?vue&type=template&id=30b46f44"
import script from "./BackToCart.vue?vue&type=script&lang=js"
export * from "./BackToCart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports